import { memo, useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { paths } from '@/shared/config/paths';
import { useAuthStore } from '@/store/useAuthStore';
// 배럴 대신 직접 경로 - 이유는 ReceptionLayout.tsx 주석 참고
import { useReceptionMode } from '@/features/reception/hooks/useReceptionMode';
import PageLoadingSkeleton from '@/shared/components/layout/PageLoadingSkeleton';

// 리셉션 모드가 활성일 때만 현장 체크인 전용 라우트 접근 허용
// 진입 시(또는 새로고침 시) 서버(Redis)의 실제 상태로 동기화 후 판단
const ReceptionGuard = () => {
	const { isAuthenticated, reception } = useAuthStore();
	const { syncStatus } = useReceptionMode();
	const [isChecking, setIsChecking] = useState(true);

	useEffect(() => {
		if (!isAuthenticated) {
			setIsChecking(false);
			return;
		}
		syncStatus().finally(() => setIsChecking(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuthenticated]);

	// 비인증 시 로그인으로
	if (!isAuthenticated) {
		return <Navigate to={paths.login.path} replace />;
	}
	// 서버 상태 확인 중
	if (isChecking) {
		return <PageLoadingSkeleton />;
	}
	// 리셉션 모드 미진입 시 관리자 홈으로
	if (!reception.active) {
		return <Navigate to={paths.home.path} replace />;
	}
	return <Outlet />;
};

export default memo(ReceptionGuard);
